import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import Manager from '../../commonComponents/Manager';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import Address from '../../commonComponents/Address';
import { AddressType } from '../../../static/types/commonTypes/addressType';
import DurationManagement from '../../commonComponents/Duration_of_the_lease_management';
import { DurationManagementType } from '../../../static/types/commonTypes/durationManagementType';
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { ManagerType } from '../../../static/types/commonTypes/managerType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}


const LocationGerance: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {



    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        manager, setManager,
        managerValidity, setManagerValidity,
        managerChecked, setManagerChecked,

        address, setAddress,
        addressValidity, setAddressValidity,
        addressChecked, setAddressChecked,

        DurationDateDébut,
        setDurationDateDébut,
        durationDateDébutValidity,
        setdurationDateDébutValidity,
        durationDateDébutChecked,
        setDurationDateDébutChecked,


        statutoryAuditor, setStatutoryAuditor,
        statutoryAuditorValidity, setStatutoryAuditorValidity,
        statutoryAuditorChecked, setStatutoryAuditorChecked,
        typeStatutoryAuditorData, setTypeStatutoryAuditorData,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

    } = useAppContext() as AppContextType
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [activiteError, setActiviteError] = useState<string | null>(null);




    // Raison Social
    const updateCompanyNameValidity = (isValid: boolean) => setCompanyNameValidity(isValid);
    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data })
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateDuration = (data: Partial<DurationManagementType>) => setDurationDateDébut({ ...DurationDateDébut, ...data });

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab("raisonSociale")
        } else if (!managerValidity && !dateValidity) {
            setActiveTab("signatureDesStatus")
        } else if (!statutoryAuditorValidity) {
            setActiveTab("laSociété")
        } else if (!addressValidity) {
            setActiveTab("adresseDuSiegeSocial")
        } else if (!durationDateDébutValidity) {
            setActiveTab("laGérance")
        }
        return companyName && managerValidity && dateValidity && statutoryAuditorValidity && addressValidity && durationDateDébutValidity
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const [formData, setFormData] = useState({
        denomination1: '',
        activite: '',
    })


    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            const managerWithRepresentativeText = (manager: ManagerType): string => {
                if (manager.person === "Personne physique") {
                    return `${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}`
                }
                else return ''
            }
            const managerauditor = (statutoryAuditor: ManagerType): string => {
                if (statutoryAuditor.person === "Personne physique") {
                    return ` ${statutoryAuditor.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${statutoryAuditor.personDetails.lastName} ${statutoryAuditor.personDetails.firstName}, demeurant ${statutoryAuditor.personDetails.address} ${statutoryAuditor.personDetails.additionalAddress ?? ""} ${statutoryAuditor.personDetails.postalCode} ${statutoryAuditor.personDetails.city}`
                }
                else if (statutoryAuditor.person === "Personne morale") {
                    return `${statutoryAuditor.entityDetails.companyName}, ${statutoryAuditor.entityDetails.legalForm} au capital de ${statutoryAuditor.entityDetails.capital} €, ayant son siège social ${statutoryAuditor.entityDetails.address} ${statutoryAuditor.entityDetails.additionalAddress ?? ""} ${statutoryAuditor.entityDetails.postalCode} ${statutoryAuditor.entityDetails.city}, ${statutoryAuditor.entityDetails.rcs} RCS ${getCityWithPreposition(statutoryAuditor.entityDetails.registrationOffice)}`
                }
                else return ''
            }
            const tempText = `Suivant acte SSP du ${date.date}
${managerWithRepresentativeText(manager)}
a confié en location-gérance à
${managerauditor(statutoryAuditor)}
un fonds de commerce de :
${formData.activite}
sis et exploité ${address.address} ${address.additionalAddress ?? ""} ${address.postalCode} ${address.city} du ${DurationDateDébut.DurationDateDébut} au ${DurationDateDébut.DurationDateFin}, renouvelable ${DurationDateDébut.DurationNature}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const [submissive, setSubmissive] = useState<boolean>(false)


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };
    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "signatureDesStatus") {
            setManagerChecked(true)
            setDateChecked(true)
            if (managerValidity && dateValidity) {
                switchTab(getNextTab("signatureDesStatus"))
            }
        } else if (activeTab === "laSociété") {
            setStatutoryAuditorChecked(true)
            if (!formData.activite) {
                setActiviteError("L'activité est obligatoire.");
            } else {
                setActiviteError(null);
            }
            if (statutoryAuditorValidity && formData.activite) {
                switchTab(getNextTab("laSociété"))
            }
        } else if (activeTab === "adresseDuSiegeSocial") {
            setAddressChecked(true)
            if (addressValidity) {
                switchTab(getNextTab("adresseDuSiegeSocial"))
            }
        }
        else if (activeTab === "laGérance") {
            setDurationDateDébutChecked(true)
            if (durationDateDébutValidity) {
                setSubmissive(true)
            }
        }
    };
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };


    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'signatureDesStatus';
            case 'signatureDesStatus':
                return 'laSociété';
            case 'laSociété':
                return 'adresseDuSiegeSocial';
            case 'adresseDuSiegeSocial':
                return 'laGérance';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'signatureDesStatus':
                return 'raisonSociale';
            case 'laSociété':
                return 'signatureDesStatus';
            case 'adresseDuSiegeSocial':
                return 'laSociété';
            case 'laGérance':
                return 'adresseDuSiegeSocial';
            default:
                return currentTab;
        }
    };

    const tabs =[
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'signatureDesStatus', label: 'Le bailleur'},
        {key: 'laSociété', label: 'Le locataire'},
        {key: 'adresseDuSiegeSocial', label: "L'adresse d'exploitation du fonds de commerce"},
        {key: 'laGérance', label: 'Durée de la location gérance'},
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>
            <ToastContainer />
            <form onSubmit={handleSubmit}>
                {
                    activeTab === "raisonSociale" &&
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={updateCompanyNameValidity}
                    />
                }
                {
                    activeTab === "signatureDesStatus" &&
                    <>
                        <Manager
                            checked={managerChecked}
                            manager={manager}
                            setChecked={setManagerChecked}
                            setManager={setManager}
                            societyType={societyTypeOptions}
                            updateManagerValidity={(isValid: boolean) => setManagerValidity(isValid)}
                            draftFieldName='manager'
                        />
                        <div>
                            <p>Date de l'AG</p>
                            <DateComponent
                                checked={dateChecked}
                                required={false}
                                date={date}
                                draftFieldName = 'date'
                                dateLabel="Date de l'acte"
                                changeDate={updateDate}
                                onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                                id='dateSignature'
                            />
                        </div>
                    </>
                }

                {activeTab === 'laSociété' && (
                    <>
                        <Manager
                            checked={statutoryAuditorChecked}
                            manager={statutoryAuditor}
                            setChecked={setStatutoryAuditorChecked}
                            setManager={setStatutoryAuditor}
                            societyType={societyTypeOptions}
                            updateManagerValidity={(isValid: boolean) => setStatutoryAuditorValidity(isValid)}
                            draftFieldName = 'statutoryAuditor'
                        />
                        <div className="mb-3 row">
                            <p>L'activité du fonds de commerce</p>
                            <label htmlFor="Activité" className="col-sm-2 col-form-label">Activité</label>
                            <div className="col-sm-10">
                                <textarea
                                    className={`form-control ${activiteError ? 'is-invalid' : ''}`}
                                    id='activite'
                                    rows={2}
                                    required
                                    value={formData.activite}
                                    onChange={(e) => {
                                        handleChange(e);
                                        setActiviteError(null);
                                    }}
                                />
                                {activiteError && <div className="invalid-feedback">{activiteError}</div>}
                            </div>
                        </div>
                    </>
                )}
                {activeTab === 'adresseDuSiegeSocial' && (
                    <Address
                        address={address}
                        draftFieldName = 'address'
                        changeAddress={(partialAddress: Partial<AddressType>) => setAddress({ ...address, ...partialAddress })}
                        checked={addressChecked}
                        onValidationChange={(isValid: boolean) => setAddressValidity(isValid)}
                    />
                )}
                {activeTab === 'laGérance' && (
                    <div>
                        <DurationManagement
                            checkedduration={durationDateDébutChecked}
                            changeDuration={updateDuration}
                            dateLabelDébut='Date de début'
                            duration={DurationDateDébut}
                            onValidationChangeDuration={(isValid: boolean) => setdurationDateDébutValidity(isValid)}
                            durationNatureOptions={[
                                "Par tactile conduction",
                                "Pas de renouvellement",
                            ]}
                        />
                        {
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </div>

                )
                }
                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "laGérance" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== "laGérance" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            activeTab === "laGérance" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>

        </>
    );
};

export default LocationGerance;
